import React from "react";
import { Button } from "../Button";

interface ToggleSwitchProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  showBorder?: boolean;
}

export function ToggleSwitch({
  label,
  checked,
  onChange,
  disabled = false,
  showBorder = true,
}: ToggleSwitchProps) {
  return (
    <div className={`flex items-center justify-between py-4 border-b-[1px] px-4 ${showBorder ? "border-[#333333]" : "border-none"}`}>
      <span>{label}</span>

      <Button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={`
          relative inline-flex h- w-9 items-center rounded-full
          transition-colors duration-200
          border-[1.5px] ${showBorder ? "border-[#333333]" : ""}
          ${checked
            ? "bg-[#451C53] border-[#E089FF]"
            : "bg-[#333333] border-[#5C5C5C]"
          }
          ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        `}
      >
        <span
          className={`
            inline-block h-4 w-4 rounded-full ${checked ? "bg-purple-gradient" : "bg-white-gradient"}
            transition-transform duration-200
            ${checked ? "translate-x-4" : "translate-x-1"}
          `}
        />
      </Button>
    </div>
  );
}
